import {componentConfig, componentLoader} from "../../lib/component_initializer";
import {ProfileBanner} from "./profile_banner";

export const profileBannerLoader = function (options = {}) {
    componentLoader(componentConfig(ProfileBanner, ProfileBanner.config.componentTypeKey, ProfileBanner.config.baseHtmlClass), options);
};
